import productTheLayout from "@/components/productTheLayout.vue";
import userTheLayout from "@/components/userTheLayout.vue";

const home = () => import(/* webpackChunkName: "Home" */ "@/views/Home.vue");
const login = () => import(/* webpackChunkName: "login" */ "@/views/login.vue");
const worksCenter = () =>
  import(/* webpackChunkName: "worksCenter" */ "@/views/worksCenter.vue");
const myStudentProduction = () =>
  import(
    /* webpackChunkName: "myStudentProduction" */ "@/views/myStudentProduction.vue"
  );
const mySubscription = () =>
  import(/* webpackChunkName: "mySubscription" */ "@/views/mySubscription.vue");
const mySubscriptionDetails = () =>
  import(
    /* webpackChunkName: "mySubscriptionDetails" */ "@/views/mySubscriptionDetails.vue"
  );
const myFeedback = () =>
  import(/* webpackChunkName: "myFeedback" */ "@/views/myFeedback.vue");
const myFeedbackEdit = () =>
  import(/* webpackChunkName: "myFeedbackEdit" */ "@/views/myFeedbackEdit.vue");
const myInformation = () =>
  import(/* webpackChunkName: "myInformation" */ "@/views/myInformation.vue");
const feedback = () =>
  import(/* webpackChunkName: "feedback" */ "@/views/feedback.vue");
const redeemThePrizeList = () =>
  import(
    /* webpackChunkName: "redeemThePrizeList" */ "@/views/redeemThePrizeList.vue"
  );
const myPrize = () =>
  import(/* webpackChunkName: "myPrize" */ "@/views/myPrize.vue");
const mySite = () =>
  import(/* webpackChunkName: "mySite" */ "@/views/mySite.vue");
const redeemPrize = () =>
  import(/* webpackChunkName: "redeemPrize" */ "@/views/redeemPrize.vue");
const newAddres = () =>
  import(/* webpackChunkName: "newAddres" */ "@/views/newAddres.vue");
const newEditres = () =>
  import(/* webpackChunkName: "newEditres" */ "@/views/newEditres.vue");
const worksCenterData = () =>
  import(
    /* webpackChunkName: "works_centerdata" */ "@/views/worksCenterData.vue"
  );
const worksComment = () =>
  import(/* webpackChunkName: "worksComment" */ "@/views/worksComment.vue");
const myStudentProductionEdit = () =>
  import(
    /* webpackChunkName: "myStudentProductionEdit" */ "@/views/myStudentProductionEdit.vue"
  );
const myStudentProductionAdd = () =>
  import(
    /* webpackChunkName: "myStudentProductionAdd" */ "@/views/myStudentProductionAdd.vue"
  );
const myStudentProductionDetail = () =>
  import(
    /* webpackChunkName: "myStudentProductionDetail" */ "@/views/myStudentProductionDetail.vue"
  );
const coursewareData = () =>
  import(/* webpackChunkName: "coursewareData" */ "@/views/coursewareData.vue");
export default [
  {
    path: "/",
    name: "productTheLayout",
    component: productTheLayout,
    redirect: { name: "home" },
    children: [
      {
        path: "/home",
        name: "home",
        component: home
      },
      {
        path: "/works/center",
        name: "works_center",
        component: worksCenter
      },
      {
        path: "/works/center/data/:id",
        name: "works_center_data",
        component: worksCenterData
      },
      {
        path: "/works/comment/:id",
        name: "works_comment",
        component: worksComment
      },
      {
        path: "/courseware/data/:id",
        name: "courseware_data",
        component: coursewareData
      },
      {
        path: "/my/subscripton/details/:id",
        name: "my_subscription_details",
        component: mySubscriptionDetails
      }
    ]
  },
  {
    path: "/my",
    name: "userTheLayout",
    component: userTheLayout,
    redirect: { name: "my_student_production" },
    children: [
      {
        path: "/my/student/production",
        name: "my_student_production",
        component: myStudentProduction
      },
      {
        path: "/my/student/production/edit/:id",
        name: "my_student_production_edit",
        component: myStudentProductionEdit
      },
      {
        path: "/my/student/production/add",
        name: "my_student_production_add",
        component: myStudentProductionAdd
      },
      {
        path: "/my/student/production/detail/:id",
        name: "my_student_production_detail",
        component: myStudentProductionDetail
      },
      {
        path: "/my/subscription",
        name: "my_subscription",
        component: mySubscription
      },
      {
        path: "/my/feedback",
        name: "my_feedback",
        component: myFeedback
      },
      {
        path: "/my/feedback/edit/:id",
        name: "my_feedback_edit",
        component: myFeedbackEdit
      },
      {
        path: "/my/information",
        name: "my_information",
        component: myInformation
      },
      {
        path: "/feedback",
        name: "feedback",
        component: feedback
      },
      {
        path: "/redeem/the/prize/list",
        name: "redeem_the_prize_list",
        component: redeemThePrizeList
      },
      {
        path: "/redeem/prize/:id",
        name: "redeem_prize",
        component: redeemPrize
      },
      {
        path: "/my/prize",
        name: "my_prize",
        component: myPrize
      },
      {
        path: "/my/site",
        name: "my_site",
        component: mySite
      },
      {
        path: "/new/addres",
        name: "new_addres",
        component: newAddres
      },
      {
        path: "/new/editres/:id",
        name: "new_editres",
        component: newEditres
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: login
  }
];
